<!--
 * @Author: zhubincong
 * @Date: 2020-3-9 19:41:31
 * @Desc: 企业监管率
 -->
<template>
  <ViewPanel title="企业监管率" :active="active">
    <div class="content">
      <div class="rate">
        <p class="rate-value">{{ accessRate }}</p>
        <p class="rate-label">监管率</p>
      </div>
      <div class="divider"></div>
      <div class="statistics">
        <div class="statistics-item">
          <p class="statistics-item-label">已监管企业数</p>
          <p class="statistics-item-value">{{ accessNumber }}</p>
        </div>
        <div class="statistics-item">
          <p class="statistics-item-label">登记企业数</p>
          <p class="statistics-item-value">{{ totalNumber }}</p>
        </div>
      </div>
    </div>
  </ViewPanel>
</template>

<script>
import ViewPanel from '../Components/ViewPanel'
import DataSet from '@antv/data-set'
import * as api from '@/api'
import riskMonitoringMixins from '@/mixins/riskMonitoringMixins'

export default {
  name: 'CompanyAccessRate',
  components: { ViewPanel },
  inject: ['$riskMonitor'],
  mixins: [riskMonitoringMixins],
  data() {
    return {
      accessNumber: 0,
      accessRate: 0,
      totalNumber: 0
    }
  },
  computed: {
    active() {
      return this.$riskMonitor.activePanel.toLowerCase() === this.$options.name.toLowerCase()
    }
  },
  mounted() {
    this.mapData = null
    this.getData()
  },
  methods: {
    /**
     * 查询企业监管统计
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getData() {
      const { data } = await api.emmsRiskMonitorQueryEnterpriseMonitoring({
        data: { projectCode: this.$store.state.projectCode }
      })
      this.accessNumber = data.accessNumber.toLocaleString()
      this.accessRate = data.accessRate + '%'
      this.totalNumber = data.totalNumber.toLocaleString()
    },
    /**
     * 查询企业区域监管统计
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getMapData() {
      const { data } = await api.emmsRiskMonitorQueryEnterpriseMonitoringMap({
        data: { projectCode: this.$store.state.projectCode }
      })
      this.mapData = data.list.map(n => {
        n.regionCode = +n.regionCode
        return n
      })
    },
    /**
     * 渲染地图
     * @author zhubincong
     * @date 2020-03-11 18:47:37
     */
    async renderMap() {
      if (!this.mapData) {
        await this.getMapData()
      }
      const { mapChart, mapView, mapDataView } = this.$riskMonitor

      // 清除其他业务图表
      mapView.clear()
      if (this.mapData.length === 0) {
        mapChart.repaint()
        return
      }
      const dv = new DataSet()
        .createView()
        .source(this.mapData)
        .transform({
          geoDataView: mapDataView,
          field: 'regionName',
          type: 'geo.region',
          as: ['longitude', 'latitude']
        })
      mapView.source(dv)
      mapView.scale({
        percent: {
          type: 'linear'
        }
      })
      mapView
        .polygon()
        .position('longitude*latitude')
        .color('accessRate', this.getRegionRankBg)
        .opacity(0.5)
        .active(true, {
          highlight: true // true 是否开启 highlight 效果，开启时没有激活的变灰
        })
        .tooltip('regionName*accessRate', (name, value) => ({ name, value: value + '%' }))
      mapChart.legend(false)
      this.$riskMonitor.$refs.centerMapRef.showRangeRateLegend = true
      mapChart.repaint()
    },
    /**
     * 刷新数据
     * @author zhubincong
     * @date 2020-03-18 17:12:42
     */
    async refreshData() {
      await this.getData()
      this.mapData = null
      if (this.active) this.renderMap()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.rate {
  background: url('~@/assets/images/RiskMonitoring/comp-rate.png') no-repeat;
  background-size: 100% 100%;
}
.rate-value {
  font-size: 32px;
  color: #00ffd9;
}
.rate-label {
  font-size: 16px;
  line-height: 44px;
  color: #8feeff;
}
.divider {
  background: url('~@/assets/images/RiskMonitoring/comp-divider.png') no-repeat;
  width: 1px;
  height: 88px;
}
.statistics-item {
  background: url('~@/assets/images/RiskMonitoring/comp-statistics.png') no-repeat;
  background-size: 100% 100%;

  + .statistics-item {
    margin-top: 10px;
  }
}
.statistics-item-label {
  font-size: 18px;
  color: #8feeff;
}
.statistics-item-value {
  font-size: 24px;
  color: #ffffff;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .view-panel {
    height: 276px;
  }
  .rate {
    width: 168px;
    height: 180px;
  }
  .rate-value {
    line-height: 58px;
  }
  .statistics-item {
    width: 238px;
    height: 84px;
    line-height: 33px;
  }
  .statistics-item-label {
    font-size: 18px;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .view-panel {
    width: 383px;
    height: 228px;
  }
  .rate {
    width: 140px;
    height: 150px;
  }
  .rate-value {
    line-height: 46px;
  }
  .statistics-item {
    width: 198px;
    height: 70px;
    line-height: 23px;
  }
  .statistics-item-label {
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
  .statistics-item-value {
    font-size: 16px;
  }
}
@media screen and (max-width: 1599px) {
  .view-panel {
    width: 306px;
    height: 182px;
  }
  .rate {
    width: 112px;
    height: 118px;
  }
  .rate-value {
    height: 38px;
    line-height: 38px;
    font-size: 20px;
  }
  .rate-label {
    height: 31px;
    line-height: 31px;
    font-size: 12px;
  }
  .statistics-item {
    width: 158px;
    height: 56px;
  }
  .statistics-item-label {
    height: 22px;
    line-height: 22px;
    font-size: 12px;
  }
  .statistics-item-value {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
  }
}
</style>
